import { render } from "./MenView.vue?vue&type=template&id=6bcd5c08"
import script from "./MenView.vue?vue&type=script&lang=js"
export * from "./MenView.vue?vue&type=script&lang=js"

import "./MenView.vue?vue&type=style&index=0&id=6bcd5c08&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__